// @deprecated Please use the Persistence Key const
export const EXPANSION_ITEM_KEY = {
    LEAD_OVERVIEW: {
        QUALIFICATION: 'lead-overview-qualification',
        DISCOVER: 'lead-overview-discover',
        CDA: 'lead-cda'
    },
    MEETING_OVERVIEW: {
        ATTENDEES: 'meeting-overview-attendees',
        EVENT: 'meeting-overview-event'
    }
};

export const PERSISTENCE_KEY = {
    CURRENT_BRIEF_ID: 'currentBriefId',
    DDM: 'ddm',
    DIRECTORY_ASSET_EXPANSION: 'directoryAssetExpansion',
    DIRECTORY_COMPANY_EXPANSION: 'directoryCompanyExpansion',
    DISCOVER: 'lead-overview-discover',
    EMAIL_PREVIEW_TEXT: 'emailPreviewText',
    MEETING_LIST_VIEW: 'meetingListView',
    PARTNER_STATUS: 'partnerStatus',
    QUALIFICATION: 'lead-overview-qualification',
    RECENT_AGREEMENT_BOARD_ID: 'recentAgreementBoardId',
    RECENT_ALLIANCE_BOARD_ID: 'recentAllianceBoardId',
    RECENT_OBLIGATION_BOARD_ID: 'recentObligationBoardId',
    RECENT_COMPANY_BOARD_ID: 'recentCompanyBoardId',
    RECENT_LEAD_BOARD_ID: 'recentLeadBoardId',
    RECENT_MEETING_BOARD_ID: 'recentMeetingBoardId',
    RECENT_VIEWED_BRIEFS_IDS: 'recentViewedBriefsIds',
    RECENT_VIEWED_CAMPAIGNS_IDS: 'recentViewedCampaignsIds',
    RECENT_VIEWED_COMPANIES_IDS: 'recentViewedCompaniesIds',
    RECENT_VIEWED_LEADS_IDS: 'recentViewedLeadsIds',
    SETTINGS_EXPANSION: 'settingsExpansion'
} as const;
